import React from "react";
import AdminHeader from "../../_components/AdminHeader/AdminHeader";
import AdminSidebar from "../../_components/AdminSidebar/AdminSidebar";
import authenticationService from "../../_services/authentication.service";

class AdminHome extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: true,
      currentUser: authenticationService.currentUserValue,
    };
  }

  handleClick = (e) => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  render() {
    const { currentUser } = this.state;
    const showClass = `page-wrapper chiller-theme ${
      this.state.isOpen ? "toggled" : ""
    }`;
    return (
      <React.Fragment>
        <div className={showClass}>
          <AdminHeader />
          <AdminSidebar handleClick={this.handleClick} />
          <main className="page-content">
            <div className="container-fluid">
              <h2>Admin Home</h2>
              <hr className="hr" />
              <div className="row">
                <div className="form-group col-md-8">
                  <p>WMT Accessory Finder | Dashboard</p>
                </div>
                <div className="form-group col-md-4">
                  <p>
                    Last Login :{" "}
                    <small className="text-muted">
                      {currentUser && currentUser.lastLogin}
                    </small>
                  </p>
                </div>
              </div>
            </div>
          </main>
        </div>
      </React.Fragment>
    );
  }
}
export default AdminHome;
